<template>
  <div class="user_left">
    <router-link :to='{name: "userInfo"}' active-class="bianlan">Personal Information<i class="el-icon-arrow-right"></i></router-link>
    <router-link :to='{name: "myDesign"}' active-class="bianlan">My Design<i class="el-icon-arrow-right"></i></router-link>
    <router-link :to='{name: "myOrder"}' active-class="bianlan">My Order<i class="el-icon-arrow-right"></i></router-link>

    <router-link :to='{name: "favorite"}' active-class="bianlan">Favorites<i class="el-icon-arrow-right"></i></router-link>
    <router-link :to='{name: "comment"}' active-class="bianlan">Browsing History<i class="el-icon-arrow-right"></i></router-link>
    <router-link :to='{name: "history"}' active-class="bianlan">Commented<i class="el-icon-arrow-right"></i></router-link>
<!--    <router-link :to='{name: "setting"}' active-class="bianlan">Security Settings<i class="el-icon-arrow-right"></i></router-link>-->
  </div>
</template>

<script>
  export default {
    name: 'userLeft',
    data () {
      return {}
    },
    methods: {}
  }

</script>

<style scoped lang="scss">
  .user_left {
    border: 1px solid #DBDBDB;
    border-radius: 10px;
    padding: 0 20px;

    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 15px;
      font-family: Poppins;
      font-weight: 400;
      color: #6E6E6F;
      line-height: 1;
      padding: 20px 0;
      border-top: 1px solid #DBDBDB;

      &:first-child {
        border: 0;
      }

      &:hover,
      &.bianlan {
        color: #662870;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// user_left.vue?0fb531f4